// Fire-and-forget product analytics (Phase 4).
// Never blocks UI, never throws. Events are allow-listed server-side.

import { getDeviceId } from "@/lib/device";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function track(event, extra = {}) {
  try {
    fetch(`${API}/analytics`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event,
        device_id: getDeviceId(),
        session_id: extra.sessionId || null,
        props: extra.props || {},
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* analytics must never break the experience */
  }
}
